import { render, staticRenderFns } from "./ModattaUploadLogoFile.vue?vue&type=template&id=da9558a6"
import script from "./ModattaUploadLogoFile.vue?vue&type=script&lang=js"
export * from "./ModattaUploadLogoFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports